import React from "react";
import { ArrowUpRight } from "lucide-react";
import {
  EQUIPMENT_COPY, EQUIPMENT_TRUCK_IMG,
} from "../../data/content";
import { Reveal, Kicker, RevealHeading } from "./primitives";
import { EquipmentRequestDialog } from "./EquipmentRequestDialog";

export const Equipment = () => (
  <section id="equipment" className="relative py-14 md:py-40 px-4 md:px-10" data-testid="equipment">
    <div className="mx-auto max-w-[1600px] grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-[8vw] items-center">
      {/* Copy */}
      <Reveal>
        <Kicker index="07">Equipment &amp; Safety</Kicker>
        <RevealHeading text="A Mobile" className="display-h2 mt-3 md:mt-5" />
        <RevealHeading text="Action Dept." className="display-h2 text-[hsl(var(--accent))]" />
        <p className="mt-5 md:mt-8 text-xs sm:text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl">
          {EQUIPMENT_COPY}
        </p>
        <div className="flex flex-wrap items-center gap-4 sm:gap-6 mt-6 md:mt-9">
          <EquipmentRequestDialog
            trigger={
              <button
                type="button"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-foreground text-background px-5 sm:px-6 py-3.5 font-mono-c text-xs tracking-[0.18em] uppercase hover:bg-[hsl(var(--accent))] hover:text-white active:scale-95 transition-all"
                data-testid="equip-request-btn"
              >
                Request Equipment Inventory <ArrowUpRight size={14} />
              </button>
            }
          />
        </div>
      </Reveal>

      {/* Typographic visual */}
      <Reveal delay={0.1} y={60}>
        <div
          className="relative aspect-[4/3] border border-border overflow-hidden"
          data-testid="equip-visual"
        >
          <img
            src={EQUIPMENT_TRUCK_IMG}
            alt="CF Action Design rigging & safety truck"
            className="absolute inset-0 h-full w-full object-cover opacity-[0.45]"
          />
          <div
            className="absolute inset-0"
            style={{ background: "linear-gradient(145deg, rgba(20,10,8,0.45), rgba(9,9,9,0.6) 65%)" }}
          />
          <div className="relative h-full p-5 sm:p-8 md:p-10 flex items-end justify-between">
            <div className="font-display uppercase font-bold leading-[0.82] tracking-tight text-[clamp(2.25rem,6.5vw,6.25rem)] text-white">
              CF<br />Rigging<br />&amp; Safety
            </div>
            <span className="text-[10px] md:text-xs text-muted-foreground text-right leading-relaxed max-w-[140px] sm:max-w-[180px]">
              Production-ready systems.<br />Where the action needs them.
            </span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
